import {ref} from 'vue';
import {CaptureType} from './../../../core/CaptureType';
interface OnDownloadData {
	file: File;
}
interface CaptureResultDisplayOptions {
	captureType: CaptureType;
	file: File;
	onDownload: (data: OnDownloadData) => void;
}

type OnDownloadCallback = (args: OnDownloadData) => void;

export class EditorCaptureResultControllerClass {
	private static _instance: EditorCaptureResultControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorCaptureResultControllerClass());
	}

	private constructor() {}

	private _displayed = ref(false);
	private _captureType = ref(CaptureType.IMAGE);
	private _file: File | undefined;
	private _onDownload: OnDownloadCallback | undefined;

	// getters
	displayed() {
		return this._displayed.value;
	}
	captureType() {
		return this._captureType.value;
	}
	file() {
		return this._file;
	}

	// mutations
	display(options: CaptureResultDisplayOptions): void {
		this._captureType.value = options.captureType;
		this._displayed.value = true;
		this._file = options.file;
		this._onDownload = options.onDownload;
	}
	download() {
		if (this._file && this._onDownload) {
			this._onDownload({file: this._file});
		}
	}
	close() {
		this._close();
		this._onDownload = undefined;
		this._file = undefined;
	}
	private _close() {
		this._displayed.value = false;
	}
}

export const CaptureResult = EditorCaptureResultControllerClass.instance();
